import { Typography, TypographyProps } from '@mui/material';
import { useDateTimeService, useDateService } from 'framework/utils/hooks/useDateService';

interface ShowDateProps extends Omit<TypographyProps, 'children' | 'component'> {
  format: string;
  dateUTC?: string;
  timezone?: string;
  isDateTime?: boolean;
  withCommaAtEnd?: boolean;
}

const ShowDate = ({
  dateUTC,
  timezone,
  format,
  isDateTime = true,
  withCommaAtEnd = false,
  variant = 'body1',
  ...typographyProps
}: ShowDateProps) => {
  const { formatDateWithTimezone } = useDateTimeService(timezone);
  const { formatDate } = useDateService();

  if (!dateUTC) return null;

  return (
    <Typography {...typographyProps} component="span" variant={variant} mr={withCommaAtEnd ? 0.5 : undefined}>
      {isDateTime ? formatDateWithTimezone(dateUTC, format) : formatDate(dateUTC, format)}
      {withCommaAtEnd ? ',' : ''}
    </Typography>
  );
};

export default ShowDate;
